<template>
  <div class="config-container">
    <h3>{{ $t('administrator.defaultCommunities.title') }}</h3>
    <div v-if="defaultCommunities.length === 0 && loaded">
      <div class="no-results">
        {{ $t('administrator.defaultCommunities.noCommunities') }}
      </div>
      <logo-background />
    </div>
    <div class="grid-layout">
      <div data-cy="default-community" v-for="community in defaultCommunities"
           :key="community.id"
           class="grid-item"
      >
        <SearchResultCommunityItem :community="community" />
        <VButton class="button-remove" type="secondary" :on-click="() => removeCommunity(community)">
          {{ $t('administrator.defaultCommunities.removeCommunity') }}
        </VButton>
      </div>
    </div>
    <div class="grid-layout">
      <div class="grid-item">
        <ConfigSelectCommunityModal type="secondary" :on-select="addCommunity">
          {{ $t('administrator.defaultCommunities.addCommunity') }}
        </ConfigSelectCommunityModal>
      </div>
    </div>
  </div>
</template>
<script>
import LogoBackground from '../shared/LogoBackground'
import VButton from '../shared/VButton'
import ConfigSelectCommunityModal from './ConfigSelectCommunityModal'
import SearchResultCommunityItem from '../search/SearchResultCommunityItem'

export default {
  name: 'ConfigPage',
  components: { VButton, SearchResultCommunityItem, LogoBackground, ConfigSelectCommunityModal },
  data() {
    return {
      loaded: false
    }
  },
  async created() {
    await this.$store.dispatch('fetchDefaultCommunities')
    this.loaded = true
  },
  methods: {
    async removeCommunity(community) {
      await this.$store.dispatch('removeDefaultCommunities', community)
      this.$toasted.global.success(this.$t('administrator.defaultCommunities.notif.removeCommunity'))
    },
    async addCommunity(community) {
      await this.$store.dispatch('addDefaultCommunities', community)
      this.$toasted.global.success(this.$t('administrator.defaultCommunities.notif.addCommunity'))
    }
  },
  computed: {
    defaultCommunities() {
      return this.$store.getters.defaultCommunities
    }
  }
}
</script>
<style scoped lang="scss">

.config-container {
  margin: 20px;
}

.grid-layout{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin: 16px;
}

.grid-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background-color: white;
  padding: 16px;
  width: 450px;
}

.grid-item:only-child {
  justify-content: center;
}

.button-remove {
  margin-left: 32px;
}
</style>
